import { useContext } from "react";

import { AuthTokenContext } from "./AuthTokenContext";

/**
 * Hook to retrieve auth token from AuthTokenProvider context.
 *
 * @see {@link AuthTokenContext} for the underlying context
 * @see {@link AuthTokenProvider} for the provider component
 *
 * @returns Current auth token or null if not provided.
 * @example const authToken = useAuthTokenContext();
 */
export function useAuthTokenContext(): string | null {
  const { authToken } = useContext(AuthTokenContext);
  return authToken;
}
